export const Show = ({
  children,
  fallback = null,
  when,
}: {
  children: React.ReactNode
  when: boolean
  fallback?: React.ReactNode
}) => (when ? children : fallback)
